import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Button from '../components/Button';
import EmptyState from '../components/EmptyState';
import styles from './DeletedView.module.scss';

const DeletedView = () => {
  const { state } = useLocation();

  if (!state?.isDeleted) return <Navigate to="/" replace />;

  return (
    <div className={styles.container}>
      <div className={styles.emptyWrapper}>
        <EmptyState
          imageName="generic"
          title="Your team was successfully deleted"
          message="All of your topics, posts, and content have been permanently deleted. We appreciate you giving Slab a try!"
          vertical
          action={
            <Button to="https://slab.com/" size="large" variant="secondary">
              Go to Slab homepage
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default DeletedView;
